<script setup>
import { UserIcon, UsersIcon } from '@heroicons/vue/16/solid';
import EmptyCardComponent from '@/components/cards/EmptyCardComponent.vue';
import TextInputComponent from '@/components/form/TextInputComponent.vue';
import BasicButtonComponent from '@/components/form/BasicButtonComponent.vue';
import SelectInputComponent from '@/components/form/SelectInputComponent.vue';
import CountriesOptionComponent from '@/components/form/CountriesOptionComponent.vue';
import {computed, ref} from 'vue';
import { useAuthStore } from '@/stores/auth';

const form = ref({
  email: '',
  password: '',
  first_name: '',
  last_name: '',
  country: '',
  password_confirmation: '',
  tc: false,
}),
 store = useAuthStore(),
 error = computed(() => store.error);
console.log(error)
</script>

<template>
  <empty-card-component
    class="p-4 rounded-xl"
    style="backdrop-filter: blur(10px); background-color: #fff9"
  >
    <template #body>
      <div class="">
        <form
          class="mb-4"
          @submit.prevent="store.register(form)"
        >
          <div class="flex items-center justify-between space-x-2">
            <div class="w-full mb-4">
              <text-input-component
                id="firstname"
                v-model:input-value="form.first_name"
                :type="`text`"
                name="firstname"
                placeholder="Firstname"
                required
                class="py-3 placeholder:text-base placeholder-gray-400"
              />
              <span
                v-if="error?.first_name?.length"
                class="text-xs text-red-500"
              >{{ error?.first_name[0] }}</span>
            </div>
            <div class="w-full mb-4">
              <text-input-component
                id="lastname"
                v-model:input-value="form.last_name"
                :type="`text`"
                name="lastname"
                placeholder="Lastname"
                required
                class="py-3 placeholder:text-base placeholder-gray-400"
              />
              <span
                v-if="error?.last_name?.length"
                class="text-xs text-red-500"
              >{{ error?.last_name[0] }}</span>
            </div>
          </div>
          <div class="flex items-center justify-between space-x-2 mb-4">
            <div class="w-full">
              <text-input-component
                id="email"
                v-model:input-value="form.email"
                :type="`email`"
                name="email"
                placeholder="Email"
                required
                class="py-3 placeholder:text-base placeholder-gray-400"
              />
              <span
                v-if="error?.email?.length"
                class="text-xs text-red-500"
              >{{ error?.email[0] }}</span>
            </div>
          </div>
          <div>
            <div>
              <select-input-component
                v-model:select-value="form.country"
                uses-slot
                placeholder="Select country..."
                class="border pt-2 mb-4"
                type="country"
              >
                <countries-option-component />
              </select-input-component>
              <span
                v-if="error?.country?.length"
                class="text-xs text-red-500"
              >{{ error?.country[0] }}</span>
            </div>
          </div>
          <div class="flex items-center justify-between space-x-2">
            <div class="w-full mb-4">
              <text-input-component
                id="password"
                v-model:input-value="form.password"
                :type="`password`"
                name="password"
                placeholder="Password"
                required
                class="py-3 placeholder:text-base placeholder-gray-400"
              />
              <span
                v-if="error?.password?.length"
                class="text-xs text-red-500"
              >{{ error?.password[0] }}</span>
            </div>
          </div>
          <div>
            <text-input-component
              id="confirm_password"
              v-model:input-value="form.password_confirmation"
              :type="`password`"
              name="confirm_password"
              placeholder="Confirm password"
              class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
            />
          </div>
          <label
            for="remember-me"
            class="text-base flex items-center"
          >
            <input
              id="remember-me"
              v-model="form.tc"
              type="checkbox"
              name="remember-me"
              required
              class="mr-2"
            >
            Accept T & C
          </label>
          <basic-button-component
            type="submit"
            class="mt-4 w-full text-lg text-white font-semibold py-3 block ml-auto bg-green-700"
          >
            Register
          </basic-button-component>
        </form>
        <div class="flex items-center justify-between mb-4">
          <router-link
            to="/login"
            class="text-base text-teal-600"
          >
            <span class="text-red-600">Have an account?</span>
            Login
          </router-link>
        </div>
        <!--        <span>-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</span> or <span>-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</span>-->
        <!--        <div class="flex flex-1 space-x-5 items-center justify-center mt-4">-->
        <!--          <a-->
        <!--            href=""-->
        <!--            target="_blank"-->
        <!--            class="border-2 border-green-700 bg-teal-700 text-white rounded-full"-->
        <!--          >-->
        <!--            <user-icon class="h-6 w-6" />-->
        <!--          </a>-->
        <!--          <a-->
        <!--            href=""-->
        <!--            target="_blank"-->
        <!--            class="border-2 border-green-700 bg-teal-700 text-white rounded-full"-->
        <!--          >-->
        <!--            <users-icon class="h-6 w-6" />-->
        <!--          </a>-->
        <!--        </div>-->
      </div>
    </template>
  </empty-card-component>
</template>

<style scoped></style>
